import { useEffect, useState } from "react";
import { formateDateTime } from "../../../utils";
import Avatar from "../../../static/images/avata.svg";
export const CustomCardMultiple = props => {
    return (
        <>
            {
                props.data.map((item) =>
                    <div class={'card ' + item.className} style={{ animation: 'fadeIn .3s' }} >
                        <div class="content-wrapper">
                            <div className="prd">
                                <img src="" alt="logo" />
                            </div>

                            <div class="prd-info">
                                <span>{item.productType}</span>
                                <h4>{item.productName}</h4>
                                <span class="prd-detail">{item.productOwner}</span>
                            </div>
                        </div>
                        <div class="policy-no">
                            <span>Policy Number</span>
                            <span>{item.policyNo}</span>
                        </div>
                    </div>
                )}
        </>
    )
};
export const CustomCardSingle = props => {
    const item = props.content;
    return (
        <div class={'card ' + props.className} style={{ animation: 'fadeIn .3s' }}>
            <div class="content-wrapper">
                <div className="prd">
                    <img src={item.display_logo} alt="logo" />
                </div>

                <div class="prd-info">
                    <span>{item.product_name}</span>
                    <h4>{item.display_value}</h4>
                    <span class="prd-detail">{item.display_discription}</span>
                </div>
            </div>
            {/* {item.ref_value && item.ref_key ?
                <div class="policy-no">
                    <span>{item.ref_key}</span>
                    <span>{item.ref_value}</span>
                </div>
                : null} */}
        </div>
    )
};

export const CustomCard = props => {
    const item = props.content;
    return (
        <div class={'card ' + props.className} style={{ animation: 'fadeIn .3s' }}>
            <div class="content-wrapper">
                <div className="prd">
                    <img src={item.display_logo} alt="logo" />
                </div>

                <div class="prd-info">
                    <span>{item.product_name}</span>
                    <h4>{item.display_value}</h4>
                    <span class="prd-detail">{item.display_discription}</span>
                </div>
            </div>
            {/* {item.ref_value && item.ref_key ?
                <div class="policy-no">
                    <span>{item.ref_key}</span>
                    <span>{item.ref_value}</span>
                </div>
                : null} */}
        </div>
    )
};



export const CardSelection = props => {
    const [viewMore, setViewMore] = useState(false)
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !props.message.selected) {
            setViewMore(true)
        }
    })
    const [count, setCount] = useState(-1);
    const [offset, setOffset] = useState(2)
    const changePage= ()=>{
        setOffset((offset)=> offset+3)
    }
    // console.log(offset, count)
    useEffect(()=>{
// if(content.choices.length>=offset){
    // props.scrollintoview(props?.id)
    props.scrollToBottom()
// }
    },[count, offset])
    useEffect(() => {
        props.GAEvent({ eventAction: "booking-listing", eventLabel: "display-listing" })
        // console.log(count)
        if (content.type && content.type === "BookingSelection" && props.message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count && count < offset) {

            const interval = setInterval(() => {
                setCount((count)=> count + 1);
                // props.scrollintoview(props.id)
                props.scrollToBottom()
            }, 500);
            return () => clearInterval(interval);
        }
    }, [count, props.message.displayAllOptions, viewMore, offset]);
    const content = JSON.parse(props.message.content);
    return (
        <>
            {content.title ? (
                <>
                    <div class="grop_message">
                        <div
                            class="message"
                            dangerouslySetInnerHTML={{ __html: content.title }}
                        />
                    </div>

                    {/* <img class="grop_message blank">
                    </img>
                    <div class=" grop_message msg-detials">
                    PB Chat <i/>{formateDateTime(props.message.sentAt)}
                    </div> */}

                </>
            ) : null}
            <>
                {props.isHistoryMessgage ? null :
                    <div class={`product-info `}>

                        {content.choices.map((item1, index) => (
                            <>{index <= count ?
                                <>
                                    {props.message.displayAllOptions || index < count || !viewMore ?

                                        <div className={`card-item hidden ${props.agentName || item1.isActive === false ? "disabled": null} ${index + 1 <= count ? 'show' : null}`} onClick={() => {props.selectOption(item1, content.type, props.message.messageId)
                                           props.GAEvent ({eventAction:"booking-selected",eventLabel:item1.display_value})}} >
                                            <CustomCardSingle
                                                content={item1}
                                                className='white'
                                            />
                                        </div>
                                        :
                                        null}

                                </>
                                : null}
                            </>
                        ))}
                        {viewMore && !props.message.displayAllOptions && count >= 2 && content.choices.length>offset ?
                            <div class="card link" onClick={() => changePage()}>
                                <h4>Need help with another policy?</h4>
                            </div>
                            : null}
                    </div>
                }
            </>



        </>)

};

export const SingleCardSelection = props => {
    const [viewMore, setViewMore] = useState(false)
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !props.message.selected) {
            setViewMore(true)
        }
    })
    const [count, setCount] = useState(3);
    useEffect(() => {
        if (content.type && content.type === "BookingSelection" && props.message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count && props.message.displayAllOptions || count < 3 || !viewMore) {

            const interval = setInterval(() => {
                setCount(count + 1);
                // props.scrollToBottom()
            }, 500);
            // scrollToBottom()
            return () => clearInterval(interval);
        }
    }, [count, props.message.displayAllOptions, viewMore]);
    const content = JSON.parse(props.message.content);
    return (
        <>
            {content.title ? (
                <>
                    <div class="grop_message">
                        <div
                            class="message"
                            dangerouslySetInnerHTML={{ __html: content.title }}
                        />
                    </div>

                </>
            ) : null}
            <>

                <div class="product-info" style={{ marginBottom: 0 }}>

                    {content.choices.map((item1, index) => (
                        <>{index <= count ?
                            <>
                                {props.message.displayAllOptions || index < 2 || !viewMore ?

                                    <div className={`card-item hidden ${index + 1 <= count ? 'show' : null}`} >
                                        <CustomCardSingle
                                            content={item1}
                                            className='balnk'
                                        />
                                    </div>
                                    :
                                    null}

                            </>
                            : null}
                        </>
                    ))}
                    {viewMore && !props.message.displayAllOptions && count > 2 ?
                        <div class="card link" onClick={() => props.displayAllOptions(props.message.messageId)}>
                            <h4>Need help with another policy?</h4>
                        </div>
                        : null}
                </div >
            </>



        </>)

};

export const SelectionList = ({
    message,
    selectOption,
    displayAllOptions,
    autoOpen,
    agentName,
    isHistoryMessgage    
}) => {
    const [viewMore, setViewMore] = useState(false)
    const [showDrawer, setShowDrawer] = useState(autoOpen || false)
    const [drawerVisible, setDrawerVisible] = useState(autoOpen || false)
    const [drawerHead , setDrawerHead] = useState(false);
    const [showMesssage ,setShowMessage] = useState(false);


    useEffect(() => {
        if (autoOpen) {
            setShowDrawer(true)
            setDrawerVisible(true)
        }
    }, [autoOpen])
    
    useEffect(() => {
        if (showDrawer) {
            setDrawerVisible(true)
            setTimeout(() => setDrawerVisible(true), 500)
        } else {
            setTimeout(() => setDrawerVisible(false), 300)
        }
    }, [showDrawer])
    
    const content = JSON.parse(message.content);

    useEffect(()=>{
        // check if content.title length less than 200 and not 0   setDrawerHead : false and   setShowMessage : true
        if(content.title && content.title.length < 200 && content.title.length > 0){
            setDrawerHead(false)
            setShowMessage(true)
        }
    },[content])
    useEffect(() => {
        // if (content.choices && content.choices.length > 2 && !props.message.selected) {
        //     setViewMore(true)
        // }
    })
    const [count, setCount] = useState(3);
    useEffect(() => {
        if (content.type && content.type === "BookingSelection" && message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count && message.displayAllOptions || count < 3 || !viewMore) {

            const interval = setInterval(() => {
                setCount(count + 1);
                // props.scrollToBottom()
            }, 500);
            // scrollToBottom()
            return () => clearInterval(interval);
        }
    }, [count, message.displayAllOptions, viewMore]);
    return (
        <>
            {content.title && content.choices.length? (
                <>
                    <div class="grop_message">
                        <div
                            class="message message-wa"
                            style={{width: '100%'}}
                            dangerouslySetInnerHTML={{ __html: content.title }}
                        />
                    </div>
                    {!message.selected && !isHistoryMessgage && (
                        content.choices && content.choices.length > 2 ? (
                            <div class="mcq">
                                <button 
                                    disabled={agentName ? true : false} 
                                    onClick={() => setShowDrawer(true)} 
                                    class="question"
                                    style={{width: '100%', textAlign: 'center'}}
                                >
                                    Select option
                                </button>
                            </div>
                        ) : (
                            <div class="mcq">
                                {content.choices.map((item1, index) => (
                                    <button 
                                        disabled={agentName ? true : false} 
                                        onClick={() => selectOption(item1, content.type, message.messageId)} 
                                        class="question"
                                        style={{width: 'auto', textAlign: 'center'}}
                                        key={index}
                                    >
                                        {item1.display_value}
                                    </button>
                                ))}
                            </div>
                        )
                    )}

                </>
            ) : null}
            {showDrawer && (
                <div 
                    class="drawer-overlay" 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.75)',
                        zIndex: 1000
                    }}
                    onClick={() => setShowDrawer(false)}
                >
                    <div 
                        class="drawer" 
                        style={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            borderRadius: '10px 10px 0 0',
                            padding: '10px 10px',
                            minHeight: '50vh',
                            maxHeight: '100vh',
                            overflowY: 'auto',
                            transform: 'translateY(0)',
                            transition: 'transform 0.3s ease-out',
                            transform: drawerVisible ? 'translateY(0)' : 'translateY(100%)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div class="drawer-header" style={{
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '0 0 0 0',
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 10
                        }}>
                            
                            <h3 style={{margin: 0, fontSize: '14px', fontWeight: '500'}}>
                                {drawerHead ? (
                                <>Select Option</>
                                ):''}
                            </h3>
                            
                            <button 
                                onClick={() => setShowDrawer(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >×</button>
                        </div>
                        <div class="drawer-content" style={{ paddingTop: '5px', maxHeight: 'calc(90vh - 100px)', overflowY: 'auto' }}>
                            {content.title && content.title.length < 200 && content.choices.length <= 6 && (
                                <div style={{ marginBottom: '20px' }}>
                                    <div
                                        className="message-wa"
                                        style={{
                                            width: '96%',
                                            backgroundColor: '#f5f7fb',
                                            borderRadius: '14px',
                                            padding: '12px 14px 18px 14px', 
                                            fontSize: '14px',
                                            color: '#253858',
                                            textAlign: 'left',
                                            letterSpacing: '0.01em',
                                            lineHeight: '1.5',
                                            position: 'relative',
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                        }}
                                    >
                                        {/* message text */}
                                        <div dangerouslySetInnerHTML={{ __html: content.title }} />

                                        {/* timestamp inside bubble */}
                                        {message?.sentAt && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '4px',
                                                    right: '12px',
                                                    fontSize: '11px',
                                                    color: 'rgba(37, 56, 88, 0.55)',
                                                }}
                                            >
                                                {new Date(message.sentAt).toLocaleTimeString([], {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            {Object.entries(
                                content.choices.reduce((groups, item) => {
                                    const group = item.display_group_name || 'Other';
                                    if (!groups[group]) groups[group] = [];
                                    groups[group].push(item);
                                    return groups;
                                }, {})
                            ).map(([groupName, items]) => {
                                const groupEntries = Object.keys(content.choices.reduce((groups, item) => {
                                    const group = item.display_group_name || 'Other';
                                    if (!groups[group]) groups[group] = [];
                                    return groups;
                                }, {}));
                                return (
                                <div key={groupName} style={{marginBottom: '20px'}}>
                                    {groupEntries.length > 1 && (
                                        <div style={{display: 'flex', alignItems: 'center', margin: '0px 0 0px 0', padding: '0px 0'}}>
                                            <span style={{color: 'rgba(37, 56, 88, 0.60)', fontSize: '15px', fontWeight: '600'}}>
                                                {groupName}
                                            </span>
                                        </div>
                                    )}
                                    {items.map((item1, index) => (
                                        <button 
                                            disabled={agentName ? true : false} 
                                            onClick={() => {
                                                selectOption(item1, content.type, message.messageId);
                                                setShowDrawer(false);
                                            }} 
                                            class="drawer-option"
                                            style={{
                                                width: '100%',
                                                padding: '12px 12px',
                                                margin: '6px 0',
                                                border: '0.5px solid #e8e8e8',
                                                borderRadius: '12px',
                                                backgroundColor: 'white',
                                                cursor: 'pointer',
                                                textAlign: 'left',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                transition: 'all 0.3s ease',
                                                position: 'relative',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8f9ff';
                                                e.currentTarget.style.borderColor = '#4285f4';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'white';
                                                e.currentTarget.style.borderColor = '#e8e8e8';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                                            }}
                                            key={index}
                                        >
                                            <div style={{flex: 1}}>
                                                <div style={{fontWeight: '600', marginBottom: '4px', color: '#253858', fontSize: '14px'}}>
                                                    {item1.display_value}
                                                </div>
                                                <div style={{fontSize: '13px', color: '#666', lineHeight: '1.3'}}>
                                                    {item1.display_discription}
                                                </div>
                                            </div>
                                            <div style={{
                                                width: '18px',
                                                height: '18px',
                                                borderRadius: '50%',
                                                border: '2px solid #e0e0e0',
                                                backgroundColor: 'white',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'all 0.3s ease',
                                                marginLeft: '12px'
                                            }}>
                                                <div style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#4285f4',
                                                    opacity: 0,
                                                    transition: 'all 0.3s ease',
                                                    transform: 'scale(0.8)'
                                                }}></div>
                                            </div>
                                        </button>
                                    ))}
                                </div>
                            )})}
                        </div>
                    </div>
                </div>
            )}
        </>
    )

};
